import React, { Component } from 'react';
// import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
//import RenderDecimalTextField from './renderDecimalTextFiel';
import { Grid, Button } from '@material-ui/core';
import { setPropsAsInitial } from '../../helpers/setPropsAsInitial';
import renderAutoComplete from './renderAutoComplete';
import RenderRadioGroup from './RenderRadioGroup';
import RenderTextFieldRedux from './RenderTextFieldRedux';
// import Autocomplete from '@material-ui/lab/Autocomplete';


const validate = values => {
    const error  = {}
    /* if (!values.entity) {
        error.entity = "El campo Tipo de Institución Financiera es obligatorio"
    }
    if (!values.institution) {
        error.institution = "El campo Nombre de Institución Financiera es obligatorio"
    }
    if (!values.type) {
        error.type = "El campo Tipo de cuenta es obligatorio"
    } */
    if (!values.name) {
        error.name = "El nombre es un campo obligatorio"
    }
    if (!values.email) {
        error.email = "El email es un campo obligatorio"
    }
    if (!values.number) {
        error.number = "La número de cuenta es un campo obligatorio"
    }
    if (!values.document) {
        error.document = "El tipo de documento es obligatorio"
    }
    if (!values.cedule) {
        error.cedule = "El campo Número de documento es obligatorio"
    }
    return error
}
class BeneficiaryForm extends Component {
    state = {
        Radiogroup: [
            {
                id: 1,
                value: 'INTERNO',
                label: 'Interno'
            },
            {
                id: 2,
                value: 'EXTERNO',
                label: 'Externo'
            }
        ],
        internal: true,
    }
    handleEntityChange = (e) => (
        this.props.setEntity(e)
    )
    handleTypeChange = (e) => {
        this.props.setType(e)
    }
    handleInstitutionChange = (e) => (
        this.props.setInstitution(e)
    )
    render() {
        const { handleSubmit, submitting, cancelPrompt, entities, institutions, document, setDocument } = this.props;
        return (
                <form  onSubmit={ handleSubmit }>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={12}>
                            <Field
                                    // {...this.state}
                                    withFocus
                                    name="entity"
                                    id="entity"
                                    required
                                    options = { entities.TiposInstitucion }
                                    field = { "Nombre" }
                                    getData = { this.handleEntityChange }
                                    // className={clsx(classes.margin, classes.textField)}
                                    component={ renderAutoComplete }
                                    label="Tipo de Institución Financiera"
                                    fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <Field
                                    // {...this.state}
                                    name="institution"
                                    id="institution"
                                    required
                                    options = { institutions }
                                    field = { "Nombre" }
                                    getData = { this.handleInstitutionChange }
                                    component={ renderAutoComplete }
                                    label="Nombre de Institución Financiera"
                                    fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <Field
                                    // {...this.state}
                                    name="type"
                                    id="type"
                                    required
                                    options = {
                                        entities.TiposCuenta.filter( external => {
                                            if (external.EsInterna) return false 
                                            else return true
                                        })
                                     }
                                    field = { "Nombre" }
                                    getData = { this.handleTypeChange }
                                    component={ renderAutoComplete }
                                    label="Tipo de cuenta"
                                    fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <Field
                                name="document"
                                id="document"
                                required
                                row
                                data = {
                                    [
                                        {label: 'Cédula', value:'1' },
                                        {label: 'RUC', value:'2' },
                                        {label: 'PASAPORTE', value:'6' },
                                    ]
                                }
                                document = {document}
                                component={ RenderRadioGroup }
                                label="Tipo de documento"
                                setVal = { setDocument }
                                valor={document}
                            >
                            </Field>
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <Field
                                withFocus
                                name="cedule"
                                id="cedule"
                                required
                                // valueData = { cedule }
                                component={ RenderTextFieldRedux }
                                label={ 'Número de documento'  }
                                type={ (document === '6') ? "text" : "number"}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <Field
                                withFocus
                                name="number"
                                id="number"
                                required
                                allowZero = { true }
                                component={ RenderTextFieldRedux }
                                label="Número de cuenta"
                                type="number"
                                fullWidth
                                /* onChange = {
                                    e => console.log(e.target.value)
                                } */
                            />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <Field
                                name="name"
                                id="name"
                                required
                                component={ RenderTextFieldRedux }
                                label="Nombre"
                                type="text"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} md={12}>
                        <Field
                            withFocus
                            name="email"
                            id="email"
                            required
                            textTransform = "lowercase"
                            component={ RenderTextFieldRedux }
                            label="Correo Electrónico"
                            fullWidth
                        />
                        </Grid>
                        <Grid item xs={6} md={6}>
                            <Button variant="contained" type="submit"
                                disabled={ submitting}
                                fullWidth
                                
                                // className= {classes.colorbutton}
                                color={'primary'}
                                >
                                Aceptar
                            </Button>
                        </Grid>
                        <Grid item xs={6} md={6}>
                            <Button variant="contained" onClick = {  cancelPrompt }  fullWidth
                                color={'primary'}
                            >
                                Cancelar
                            </Button>
                        </Grid>
                    </Grid>
                </form>
        )
    }
}

const BeneficiaryReduxForm = reduxForm(
    {
      form: 'BeneficiaryForm',
      validate
    }
)(BeneficiaryForm)
export default setPropsAsInitial(BeneficiaryReduxForm)

// export default BeneficiaryForm;